import React, { useState } from "react";
import { Table, Input } from "antd";
import { Avatar_01 } from "../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import AddUserDataModal from "./AddUserDataModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchUsers } from "./store/userDataSlice";
import { useDispatch } from "react-redux";
const UserDataTable = ({ data, loading }) => {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <div className="table-avatar">
          <Link to="/profile">{text}</Link>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (role) => {
        // Supports a single role (object/string) or multiple roles (array).
        const roles = Array.isArray(role) ? role : role ? [role] : [];
        const names = roles
          .map((r) => (typeof r === "string" ? r : r?.name))
          .filter(Boolean);
        if (names.length === 0) {
          return <span className="text-muted">No role</span>;
        }
        return names.map((name) => (
          <span
            key={name}
            className={`badge me-1 ${
              name === "Admin" || name === "Super Admin"
                ? "bg-inverse-danger"
                : "bg-inverse-success"
            }`}
          >
            {name}
          </span>
        ));
      },
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="text-start">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${record.id}`}>Edit</Tooltip>}
          >
            <Link
              to="#"
              className="btn btn-icon btn-primary btn-sm"
              onClick={() => {
                setSelectedUserId(record.id);
                setIsModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#3498db",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-pencil" />
            </Link>
          </OverlayTrigger>
        </div>
      ),
    }
  ];
  

  return (
    <div className="row">
    <div className="col-md-12">
      <div className="d-flex justify-content-end mb-4">
          <Input
            placeholder="Search User Name, User Phone"
            style={{ width: 200 }}
            onKeyUp={(e) => {
              dispatch(fetchUsers(e.target.value));
            }} 
          />
      </div>
      <div className="table-responsive">
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: 10, // Keep a fixed number of items per page
          showSizeChanger: false, // Hide the "per page" dropdown
        }}
      />
      {isModalOpen && (
        <AddUserDataModal
          show={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          userId={selectedUserId}
        />
      )}
      </div>
    </div>
  </div>
    // <div className="table-responsive">
      
      
    // </div>
  );
};

export default UserDataTable;
